/** Remove a formatação de CPF/CNPJ e normaliza letras para maiúsculas. */
export const normalizeCpfCnpj = (value?: string | null): string => String(value ?? "")
  .toUpperCase()
  .replace(/[^A-Z0-9]/g, "");

/**
 * Valida o formato aceito no campo: CPF numérico ou CNPJ numérico/alfanumérico.
 * Esta função não calcula os dígitos verificadores.
 */
export const isValidCpfCnpjFormat = (value?: string | null): boolean => {
  const document = normalizeCpfCnpj(value);

  return /^\d{11}$/.test(document) || /^[A-Z0-9]{12}\d{2}$/.test(document);
};
